import PropTypes from 'prop-types'
import React from 'react'

import { H2, Text } from 'styles/components/typography'

import { StyledYouTubePlayer, MobileWrapper, StyledIcon } from '../styles'

const FullSizeVideoBlockMobile = ({ data, cover, isTextInnerOnMobile }) => {
  const contentOuter = !isTextInnerOnMobile ? (
    <div className="row">
      <div className="col-12 col-md-6 offset-md-6 col-lg-7 text-center">
        <H2 dangerouslySetInnerHTML={{ __html: data.title }} />
        <Text
          className="mb-3"
          dangerouslySetInnerHTML={{ __html: data.content }}
        />
      </div>
    </div>
  ) : null

  const contentInner = isTextInnerOnMobile ? (
    <div className="text-white p-2">
      <H2 dangerouslySetInnerHTML={{ __html: data.title }} />
      <Text
        className="mb-3"
        dangerouslySetInnerHTML={{ __html: data.content }}
      />
      {data.icon && <StyledIcon id={data.icon} />}
    </div>
  ) : null

  return (
    <MobileWrapper innerText={isTextInnerOnMobile}>
      {contentOuter}

      <StyledYouTubePlayer
        content={contentInner}
        videoId={data.media.id}
        cover={cover}
      />
    </MobileWrapper>
  )
}

FullSizeVideoBlockMobile.propTypes = {
  data: PropTypes.object.isRequired,
  cover: PropTypes.string.isRequired,
  isTextInnerOnMobile: PropTypes.bool,
}

export default FullSizeVideoBlockMobile
